






















import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {ManagingCompanies} from "@/models/ManagingCompanies";
import {OprEntityKeys} from "@/models/OprEntityKeys";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";

@Component({})
export default class MemberActivityLoanGrid extends FeedbackComponent {

  @Prop(String) memberIdNum!: string;

  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string;
  @Getter('oprEntityKey', StoreNamespace.AUTHENTICATION) oprEntityKey!: number
  @Action('getMemberActivityLoan', StoreNamespace.CUSTOMER_SERVICE) getMemberActivityLoan: any;


  private columns: GridColumn[] = [];
  private correctDate: string = ''

  mounted() {
    this.initColumns();

    if (this.memberIdNum) {

      this.getMemberActivityLoan({
        pathVariable: this.memberIdNum,
        requestorCallback: this
      })
    }
  }



  initColumns(): void {
    this.columns.push({property: 'loanNum', header: 'activityLoans.loanNumber'} as GridColumn);

    if (!this.isTaasiaAvirit()) {
      this.columns.push({property: 'accountNum', header: 'activityLoans.accountNumber'} as GridColumn);
      this.columns.push({property: 'loanType', header: 'activityLoans.loanType'} as GridColumn);
    }

    this.columns.push({property: 'loanSum', header: 'activityLoans.loanAmount'} as GridColumn);

    if (this.isOprEntityHapoalim()) {
      this.columns.push({property: 'interestAmount', header: 'activityLoans.interestAmount'} as GridColumn);
    }

    this.columns.push({property: 'debtSum', header: 'activityLoans.debtBalance'} as GridColumn);

    this.columns.push({property: 'updatedInterest', header: 'activityLoans.interest'} as GridColumn);
    this.columns.push({property: 'loanStartDate', header: 'activityLoans.loanStartDate'} as GridColumn);
    this.columns.push({property: 'loanpStartDate', header: 'activityLoans.loanpStartDate'} as GridColumn);
    this.columns.push({property: 'loanpEndDate', header: 'activityLoans.loanEndDate'} as GridColumn);
    this.columns.push({
      property: 'remainingInterestPayments',
      header: 'activityLoans.paymentBalance'
    } as GridColumn);


    if (this.isOprEntityHapoalim()) {
      this.columns.push({
        property: 'lastPaymentSum',
        header: 'activityLoans.lastPaymentSum'
      } as GridColumn);
    }

    this.columns.push({
      property: 'fairWorth',
      header: 'activityLoans.fairWorth'
    } as GridColumn);
  }

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'findMembersOrEmployersFor/activityLoan':
        this.$emit('successResults', data)

        if (data.results.length > 0) {
          this.correctDate = data.results[0].dataDate;
        }
        break;
    }

  }

  private isTaasiaAvirit(): boolean {
    return this.mngCompanyName === ManagingCompanies.TAASIA_AVIRIT.toLowerCase()
  }

  private isOprEntityHapoalim(): boolean {
    return this.oprEntityKey === OprEntityKeys.BANK_HAPOALIM;
  }

}


